import styled from '@xstyled/styled-components';
import React, { forwardRef } from 'react';
import { t } from 'ttag';
import { createPortal } from 'react-dom';
import { select } from '~/lib/select';
import { HelpButtonEds } from '~/ui/buttons';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { HelpPages, useHelpStore } from './Store';

const Button = styled(HelpButtonEds)`
  position: fixed;
  top: 74px;
  right: 8px;
  font-size: 30px;
  z-index: hud;
  &:focus {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid var(--color-focus-ring-inner);
    pointer-events: none;
  }
  /* @media ((max-width: 580px) and (max-height: 300px)) {
    top: 50px;
    right: 10px;
  }
  @media (max-height: 220px) {
    top: 48px;
    right: 10px;
  } */
`;

const selector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenHelpMenuButton = forwardRef<HTMLButtonElement>(
  function OpenHelpMenuButton(_props, ref) {
    const { toggle, setPage } = useHelpStore();
    const { pause } = useMediaPlayerStore(selector);

    return createPortal(
      <Button
        ref={ref}
        aria-label={t`Help`}
        onClick={() => {
          setPage(HelpPages.Root);
          pause();
          toggle();
        }}
      />,
      document.getElementById('root')!
    );
  }
);
